import log from "loglevel";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { FAQPage } from "@/components/pages/faq/FAQPage";

export default FAQPage;

export const getStaticProps: GetServerSideProps = async context => {
  try {
    return {
      props: {
        ...(await serverSideTranslations(context.locale as string, [
          "common",
          "homepage",
          "more-drawer",
          "faq"
        ]))
      }
    };
  } catch (e) {
    log.error("%0", e);

    return {
      props: {
        notFound: true
      }
    };
  }
};
